import React, {useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';
import {ApiService, Communications, localStore} from "./helpers";
import {loginUser, logoutUser, updateLoginUser} from "./store/actions/auth.action";
import MainRouter from "./navigation/navigator";
import './App.scss';
import 'react-toastify/dist/ReactToastify.css';
// @ts-ignore
import packageData from '../package.json';


import {ENV} from "./constants";
import {
    fetchCustomersConfigRequest,
    fetchHcpTypeRequest, fetchRegionsRequest, getSpecialitiesRequest,
} from "./store/actions/meta.action";
import ThemeRegistry from "./theme/ThemeRegistry";
import ConfirmationComponent from "./components/confirmation/ConfirmationComponent";
import AlertComponent from "./components/alert/AlertComponent";

const APP_VERSION = packageData.version;
// console.log(process.env);
const App = () => {
    const dispatch = useDispatch();
    const [isPageLoading, setIsPageLoading] = useState(true);


    useEffect(() => {
        let user = null;
        const userString = localStore.getItem('currentJobBoardUser');
        if (userString) {
            try {
                user = JSON.parse(userString);
            } catch (e) {
                user = null;
            }
        }
        const token = localStore.getItem('currentJobBoardToken');
        if (token) {
            ApiService.get(ENV.API_URL + 'login', {}, {'Authorization': 'Bearer ' + token})
                .then((resp) => {
                    user = resp.data.user;
                    dispatch(loginUser(user, token));
                    dispatch(fetchHcpTypeRequest());
                    dispatch(getSpecialitiesRequest());
                    dispatch(fetchRegionsRequest());
                    dispatch(fetchCustomersConfigRequest());
                    setIsPageLoading(false);
                }).catch((err) => {
                setIsPageLoading(false);
                dispatch(logoutUser());
            });
        } else {
            if (user) {
                dispatch(updateLoginUser(user));
            }
            setIsPageLoading(false);
            // dispatch(logoutUser());
        }
    }, [dispatch]);

    useEffect(() => {
        const pageLoadingSub = Communications.PageLoadingStateSubject.subscribe(isPageLoading => {
            setIsPageLoading(isPageLoading);
        });
        return () => {
            pageLoadingSub.unsubscribe();
        };
    }, []);

    useEffect(() => {
        dispatch(fetchRegionsRequest());
        dispatch(fetchHcpTypeRequest());
        dispatch(getSpecialitiesRequest());
        dispatch(fetchCustomersConfigRequest());
    }, [dispatch]);


    return (
        <div className="app-root">
            <ThemeRegistry>
                <AlertComponent/>
                <ConfirmationComponent/>
                <MainRouter/>
            </ThemeRegistry>
            {isPageLoading && <div className="page-loading"/>}
            <div className="app_version_wrapper">
                <div>
                    © Copyright 2026 Powered by
                    <span
                        style={{
                            color: '#00aaff',
                            textDecoration: 'underline',
                            cursor: 'pointer'
                        }}
                        onClick={() => window.open('https://varshealth.com', '_blank')}>
                                {" "}VarsHealth{" "}
                            </span>
                    | All Rights Reserved
                </div>
                <div>
                    v {APP_VERSION}
                </div>
            </div>
        </div>
    );
};

export default App;
